import script from "./PaymentCredentialsStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentCredentialsStep.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentCredentialsStep.vue?vue&type=style&index=0&id=63674fb8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63674fb8"]])

export default __exports__